import React, { useState } from "react";
import WinLogo from "../../assets/images/win/logo-win.svg";
import RequestModal from "./RequestModal";
import { useSelector } from "react-redux";
import axios from "axios";
import { Endpoints } from "../../Global/Endpoints";
import ErrorModal from "../Security/ErrorModal";
import { error } from "pdf-lib";
import { useNavigate } from "react-router-dom";
const PediatricCare = () => {
  
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const userInfo = useSelector((state) => state.userData?.userData);
  const token = localStorage.getItem("AccessToken");
  const [showerrorModal, setShowerrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const isHighmarkPortal = useSelector((state) => state.isHighmarkPortal);
  const [isLoading, setIsLoading] = useState(false);

  const saveBlueberryDetails = async() => {
    try {
      setIsLoading(true);
      const payload = `_Params=${encodeURIComponent(
        JSON.stringify(
          { PreferredFirstName: userInfo.PreferredName ? userInfo.PreferredName : userInfo.FirstName || "",
            LastName: userInfo.LastName,
            EmailId: userInfo.EmailID,
            MemberId: userInfo.MemberID ,
            Contract: userInfo.ContractIdentified,
          })
      )}`;
      const response = await axios.post(Endpoints.SaveBlueBerryDetails, payload, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: `Bearer ${token}`,
        },
      });
      if(response.data.result === 1){
        setShowModal(true);
      }
      else{
        setShowerrorModal(true);
        setErrorMessage(response.data.resultText || "Error saving Blueberry details. Please try again.");
      }
    } catch (error) {
      console.error("Error saving Blueberry details:", error);
      setShowerrorModal(true);
      setErrorMessage("Error saving Blueberry details. Please try again.");
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <>
      {/* Loader overlay */}
      {isLoading && (
        <div className="loading-container">
          <div className="loading"></div>
          <h2 className="loading-text">Loading...</h2>
        </div>
      )}
      {/* Header */}
      {isHighmarkPortal && <header>
        <nav className="navbar navbar-expand-lg container-fixed">
          <a className="navbar-brand" href="#">
            <img src={WinLogo} alt="WIN Logo" className="logo brand-logo" />
          </a>
        </nav>
      </header>}

      <div className="pediatric-wrapper">
        <div className="pediatric-container">
          <div className="col-md-12 col-lg-12 mt-4 inner-page-heading-wrapper">
                <button className="win-back-button" onClick={()=>{navigate(-1)}}>
                    <span>
                        <i className="bi bi-chevron-left"></i> Back
                    </span>
                </button>
                </div>

          {/* TITLE */}
          <h1 className="pediatric-heading">
            <span className="pink">{isHighmarkPortal && "WINkid"  }<br />24/7 Pediatric Care</span>
            <br />
            <span className="subheading">—Powered by Blueberry Pediatrics</span>
          </h1>

          {/* DESCRIPTION */}
          <p className="pediatric-text mt-3">
            You have 24/7 access to board-certified pediatricians—plus a free Blueberry Home Kit
            for at-home support.
          </p>

          <p className="pediatric-text mt-3">
            Tap below to request access. We’ll confirm your eligibility and email you next steps.
          </p>

          {/* CTA BUTTON */}
          <div className="mt-4">
            <button 
              className="pediatric-btn"
              onClick={saveBlueberryDetails}
              disabled={isLoading}
            >
              Request Access
            </button>
          </div>

          {/* HOME KIT SECTION */}
          <h2 className="pediatric-section-title mt-5">
            The Blueberry<br />Home Kit includes:
          </h2>

          <ul className="pediatric-list">
            <li>
              <strong>Pulse oximeter</strong> to measure oxygen levels and heart rate
            </li>
            <li>
              <strong>Video otoscope</strong> for checking ears and throat
            </li>
            <li>
              <strong>Thermometer</strong> for fast, reliable readings
            </li>
          </ul>

          <p className="pediatric-text mt-3">
            This kit helps Blueberry’s clinical team assess your child with confidence—anytime, anywhere.
          </p>

          <p className="pediatric-text mt-3">
            <strong>To get started,</strong> simply request access below.
            We’ll share your information securely with Blueberry. Once your eligibility is confirmed,
            you’ll receive an email to create your account and request your kit.
          </p>

        </div>
      </div>

      {/* MODAL COMPONENT */}
      {showModal && (
        <RequestModal 
         show={showModal}
          onClose={() => setShowModal(false)}
        />
      )}
      <ErrorModal
        show={showerrorModal}
        message={errorMessage}
        onClose={() => setShowerrorModal(false)}
        onOkay={() => setShowerrorModal(false)}
      />
    </>
  );
};

export default PediatricCare;
